import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForRequestDeclined = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtRequestDeclined($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtRequestDeclined(input: $input) {
			userErrors
			success
		}
	}
`);
